// The next own fleet of the key `next_fleet` (R3268, ui-map-interface.md
// §9): shift with n walks the own fleets at sea in the order of their id,
// so the walk is stable while fleets come and go, and after the last it
// starts again at the first.

/** The fleet after `current` in the order of the id, or the first fleet
 *  when `current` is the last or names no fleet (0); null with no fleet. */
export function nextFleetId(ids: readonly number[], current: number): number | null {
  if (ids.length === 0) return null;
  const sorted = [...ids].sort((a, b) => a - b);
  return sorted.find((id) => id > current) ?? sorted[0];
}
